









































































































































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import BottomNavigation from "../components/common/bottom-navigation/bottom-navigation.vue";
import BottomNavigationItem from "../components/common/bottom-navigation/bottom-navigation-item.vue";
import UserAvatar from "../components/common/user-avatar.vue";
import UserEditor from "../components/billing/user-editor.vue";
import SetupOwners from "../components/billing/setup-owners.vue";
import PriorityList from "../components/billing/priority-list.vue";
import Modal from "../components/common/confirm.js";

export default Vue.extend({
  components: {
    BottomNavigation,
    BottomNavigationItem,
    UserAvatar,
    UserEditor,
    SetupOwners,
    PriorityList,
  },
  props: {
    id: [Number, String],
  },
  data() {
    return {
      showUserEditor: false,
      edittingUser: null,
      lastMenuItemName: "profile",
      currentMenuItemName: "profile",
      showOwnerSetup: false,
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111-111-1111,
    };
  },
  computed: {
    ...mapState("billing", ["loading", "billingAccount"]),
    ...mapGetters("billing", ["currentBillingAccountInviteRoles", "inviteMessage"]),
    ...mapState("session", ["user"]),
    currentUser() {
      let context = this as any;
      if (context.billingAccount && context.billingAccount.members && context.id) {
        let users = context.billingAccount.members.filter((m) => m.memberId.toString() === context.id);
        if (users.length === 1) {
          return users[0];
        }
      }

      return null;
    },
    currentUserRoleText() {
      let context = this as any;
      if (context.currentBillingAccountInviteRoles && context.currentUser && context.currentUser.role) {
        if (context.isPrimaryOwner(context.currentUser)) {
          return "Primary Account Owner";
        }

        if (context.isOwner(context.currentUser)) {
          return "Account Owner";
        }

        let roles = context.currentBillingAccountInviteRoles.filter((r) => r.value === context.currentUser.role);
        if (roles.length === 1) {
          return roles[0].title;
        }
      }

      return "";
    },
    breadcrumbTitle() {
      let context = this as any;
      return context.currentUser ? ` > ${context.currentUser.memberName} > ` : "";
    },
  },
  watch: {
    id(value) {},
    user(newValue) {
      if (newValue) {
        (this as any).selectedMemberId = newValue.id;
 
        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  mounted() {
    let context = this as any;

    let tab = context.$route.query.tab;
    if (tab) {
      context.handleMenuSelect(tab);
    }

    this.loadJoinedGroups();

    abp.event.on("abp.notifications.received", context.handleNotificationReceived);
  },
  beforeDestroy() {
    let context = this as any;
    abp.event.off("abp.notifications.received", context.handleNotificationReceived);
  },
  methods: {
    loadJoinedGroups() {
      this.$store
        .dispatch("billing/getJoinedGroups", { data: { memberId: this.id } })
        .then((response) => {})
        .finally(() => {});
    },
    isPrimaryOwner(user) {
      let context = this as any;
      return context.billingAccount && user && user.role === 1 && context.billingAccount.originalOwnerId === user.memberId;
    },
    isOwner(user) {
      let context = this as any;
      return context.billingAccount && user && user.role === 1;
    },
    getUserStatus(user) {
      if (!user.licenseAssigned) {
        return "unlicensed";
      } else {
        return user.accepted ? "active" : "pending";
      }
    },
    getUserStatusStyle(user) {
      if (!user.licenseAssigned) {
        return "error";
      } else {
        return user.accepted ? "success" : "warning";
      }
    },
    getUserStatusText(user) {
      if (!user.licenseAssigned) {
        return "Unlicensed";
      } else {
        return user.accepted ? "Active" : "Pending";
      }
    },
    handleMenuSelect(name) {
      this.currentMenuItemName = name;

      if (this.lastMenuItemName === "xxxxx") {
      }
      this.lastMenuItemName = name;
    },
    handleNotificationReceived(userNotification) {
      console.log(userNotification);
      if (userNotification.notification.entityId === this.id && userNotification.notification.data.version >= 0) {
      }
    },
    sendLoginLink() {
      let user = this.currentUser;
      this.$store
        .dispatch("billing/sendLoginUrl", {
          data: {
            memberId: user.memberId,
          },
        })
        .then((response) => {
          this.$Notice.success({
            title: "Send login Link",
            desc: "Success! ",
          });
        })
        .finally(() => {});
    },
    reinviteUser() {
      let user = this.currentUser;
      this.$store
        .dispatch("billing/inviteMember", {
          data: {
            memberId: user.memberId,
            email: user.memberEmailAddress,
            role: user.role,
            message: (this as any).inviteMessage,
            isReinvite: true,
            billingAccountId: user.billingAccountId,
          },
        })
        .then((response) => {
          this.$Notice.success({
            title: "Re-Invite",
            desc: "Success! ",
          });
        })
        .finally(() => {});
    },
    archiveUser() {
      let user = this.currentUser;
      if (user.licenseAssigned === true) {
        Modal.confirm({
          title: "Remove user license?",
          content:
            "<p>When you remove a user's license...</p><ul style='margin-left: 24px;'><li>The user cannot access this GOATSUCCESS account</li><li>The user's history will remain in this GOATSUCCESS account</li><li>The license will be available to assign to a different user</li></ul>",
          okText: "Remove user license",
          cancelText: "Never mind",
          onOk: () => {
            this.$store.dispatch("billing/removeLicense", { data: { memberId: user.memberId } }).then(() => {
              this.$Notice.success({
                title: "Remove user license",
                desc: "Success! ",
              });
            });
          },
        });
      }
    },
    unarchiveUser() {
      let user = this.currentUser;
      if (!user.licenseAssigned) {
        this.$store.dispatch("billing/assignLicense", { data: { memberId: user.memberId } }).then(() => {
          this.$Notice.success({
            title: "Restore License",
            desc: "Success! ",
          });
        });
      }
    },
    handleEdit() {
      this.edittingUser = this.currentUser;
      this.showUserEditor = true;
    },
    handleShowOwnerSetup() {
      let context = this as any;
      this.showOwnerSetup = true;
    },
  },
});
